import $ from "jquery";
import moment from "moment";


/**
 * Toast with default options set
 * @param options
 */
export function toast(options) {
    $.toast({
        hideAfter: 5000,
        position: 'top-right',
        heading: options.heading,
        text: options.text,
        icon: options.icon
    });
}
/**
 * Select2 (ajax version) with default options set
 * @param options
 */
export function select2Ajax(options) {
    if (options.selected !== undefined && options.selected && options.selected.length) {
        $.ajax({
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: options.url.replace('/select2', '/select2/selected'),
            type: 'get',
            data: {q: options.selected},
            success: function (response) {
                if (response.id !== undefined) {
                    $(`${options.selector}`).append($('<option>', {value: response.id, text: response.text}));
                }
            }
        });
    }

    $(`${options.selector}`).select2({
        theme: "bootstrap4",
        maximumSelectionSize: 10,
        minimumInputLength: 1,
        language: {
            noResults : function () { return 'No se han encontrado resultados'; },
            searching: function () { return 'Buscando...'; },
            loadingMore: function () { return 'Cargando más resultados...'; },
            inputTooShort: function (args) {
                var remainingChars = args.minimum - args.input.length;
                var message = 'Por favor ingrese ' + remainingChars + ' o más caracteres';
                return message;
            },
            errorLoading: function () { return 'No se pudieron cargar los resultados'; },

        },
        multiple: Boolean(options.multiple || false),
        allowClear: true,
        placeholder: options.placeholder || '',
        ajax: {
            delay: 250,
            type: 'get',
            url: options.url,
            allowClear: true,
            dataType: 'json',
            params: {
                contentType: "application/json"
            },
            data: function (term, page) {
                return {q: term};
            },
            processResults: function(data) {
                return {results: data}
            }
        },
        escapeMarkup: function (markup) { return markup; },
        templateResult: function (item) {
            if (item.loading) {
                return item.text;
            }
            return `<div>${item.text}</div>`;
        },
        templateSelection: function (item) {
            return item.text;
        }
    });
}


export function sliderInput(options)
{
    $(`${options.selector}`).ionRangeSlider({
        values: options.values,
        skin: "square",
        grid: true,
        from: options.selected,
        from_shadow: true,
        prettify: function (n) {

            var ind = options.values.indexOf(n);
            $('.irs-handle').css('border-color',options.colors[ind]);
            $('.irs-single').css('background-color',options.colors[ind]);
            $('.irs--square .irs-bar').css('background-color',options.colors[ind]);

            return options.labels[ind];
        },
        onStart: function(data) {

        },
        onChange: function(data) {

        }
    });
}

/**
 * DateRangePicker with default options set
 * @param options
 */
export function dateRangePicker(options) {
    let format = options.format || 'YYYY-MM-DD';
    let dateRangePickerOptions = {
        autoUpdateInput: false,
        alwaysShowCalendars: true,
        locale: {
            format: format,
            applyLabel: "Guardar",
            cancelLabel: "Cancelar",
            fromLabel: "Desde",
            toLabel: "Hasta",
            customRangeLabel: "Personalizar",
            daysOfWeek: [
                "Do",
                "Lu",
                "Ma",
                "Mi",
                "Ju",
                "Vi",
                "Sa"
            ],
            monthNames: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Setiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ],
            firstDay: 1,
        },
        ranges: {
            'Hoy': [moment(), moment()],
            'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
            'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
            'Este mes': [moment().startOf('month'), moment().endOf('month')],
            'Mes pasado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    }
    if (options.minDate !== undefined) {
        dateRangePickerOptions.minDate = options.minDate;
    }
    if (options.maxDate !== undefined) {
        dateRangePickerOptions.maxDate = options.maxDate;
    }
    if (options.startDate !== undefined) {
        dateRangePickerOptions.startDate = options.startDate;
    }
    if (options.endDate !== undefined) {
        dateRangePickerOptions.endDate = options.endDate;
    }
    if (options.opens !== undefined) {
        dateRangePickerOptions.opens = options.opens;
    }
    let input = $(`${options.selector}`);
    input.daterangepicker(dateRangePickerOptions, function (start, end, label) {
        input.val(start.format(format) + ' - ' + end.format(format));
    });
    if (input.val() && input.val().includes(' - ')) {
        let parts = input.val().split(' - ');
        input.data('daterangepicker').setStartDate(parts[0]);
        input.data('daterangepicker').setEndDate(parts[1]);
    }
}

export function singleDatePicker(options)
{
    let format = options.format || 'YYYY-MM-DD';
    let dateRangePickerOptions = {
        singleDatePicker: true,
        showDropdowns: true,
        minYear: moment().format('YYYY'),
        locale: {
            format: format,
            applyLabel: "Guardar",
            cancelLabel: "Cancelar",
            fromLabel: "Desde",
            toLabel: "Hasta",
            customRangeLabel: "Personalizar",
            daysOfWeek: [
                "Do",
                "Lu",
                "Ma",
                "Mi",
                "Ju",
                "Vi",
                "Sa"
            ],
            monthNames: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Setiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ],
            firstDay: 1,
        },
    }

    if (options.minDate !== undefined) {
        dateRangePickerOptions.minDate = options.minDate;
    }
    if (options.maxDate !== undefined) {
        dateRangePickerOptions.maxDate = options.maxDate;
    }

    $(`${options.selector}`).daterangepicker(dateRangePickerOptions, function (start, end, label) {
    });
}


/**
 * DateRangePicker with default options set
 * @param options
 */
export function dateRangePickerWithHours(options) {
    let format = options.format || 'YYYY-MM-DD';
    let dateRangePickerOptions = {
        autoUpdateInput: false,
        alwaysShowCalendars: true,
        timePicker: true,
        timePicker24Hour: true,
        locale: {
            format: format,
            applyLabel: "Guardar",
            cancelLabel: "Cancelar",
            fromLabel: "Desde",
            toLabel: "Hasta",
            customRangeLabel: "Personalizar",
            daysOfWeek: [
                "Do",
                "Lu",
                "Ma",
                "Mi",
                "Ju",
                "Vi",
                "Sa"
            ],
            monthNames: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Setiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ],
            firstDay: 1,
        },
        ranges: {
            'Hoy': [moment(), moment()],
            'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
            'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
            'Este mes': [moment().startOf('month'), moment().endOf('month')],
            'Mes pasado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    }
    if (options.minDate !== undefined) {
        dateRangePickerOptions.minDate = options.minDate;
    }
    if (options.maxDate !== undefined) {
        dateRangePickerOptions.maxDate = options.maxDate;
    }
    if (options.startDate !== undefined) {
        dateRangePickerOptions.startDate = options.startDate;
    }
    if (options.endDate !== undefined) {
        dateRangePickerOptions.endDate = options.endDate;
    }
    if (options.opens !== undefined) {
        dateRangePickerOptions.opens = options.opens;
    }
    let input = $(`${options.selector}`);
    input.daterangepicker(dateRangePickerOptions, function (start, end, label) {
        input.val(start.format(format) + ' - ' + end.format(format));
    });
    if (input.val() && input.val().includes(' - ')) {
        let parts = input.val().split(' - ');
        input.data('daterangepicker').setStartDate(parts[0]);
        input.data('daterangepicker').setEndDate(parts[1]);
    }
}

/**
 * DateRangePicker with default options set
 * @param options
 */
export function singleDateRangePickerWithHours(options) {
    let format = options.format || 'YYYY-MM-DD';
    let dateRangePickerOptions = {
        autoUpdateInput: false,
        alwaysShowCalendars: true,
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        locale: {
            format: format
        }
    }
    if (options.minDate !== undefined) {
        dateRangePickerOptions.minDate = options.minDate;
    }
    if (options.maxDate !== undefined) {
        dateRangePickerOptions.maxDate = options.maxDate;
    }
    if (options.startDate !== undefined) {
        dateRangePickerOptions.startDate = options.startDate;
    }
    if (options.endDate !== undefined) {
        dateRangePickerOptions.endDate = options.endDate;
    }
    if (options.opens !== undefined) {
        dateRangePickerOptions.opens = options.opens;
    }
    let input = $(`${options.selector}`);
    input.daterangepicker(dateRangePickerOptions, function (start, end, label) {
        input.val(start.format(format));
    });
    if (input.val() && input.val().includes(' - ')) {
        let parts = input.val().split(' - ');
        input.data('daterangepicker').setStartDate(parts[0]);
        input.data('daterangepicker').setEndDate(parts[1]);
    }
}